import { render, staticRenderFns } from "./ChangeResponsablePromptModal.vue?vue&type=template&id=5e4c6b40&scoped=true"
import script from "./ChangeResponsablePromptModal.vue?vue&type=script&lang=js"
export * from "./ChangeResponsablePromptModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeResponsablePromptModal.vue?vue&type=style&index=0&id=5e4c6b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c6b40",
  null
  
)

export default component.exports